import request from '@/utils/ajax';


export function addOss(data){
  return request({
    url: `/wx/sys/oss/saveConfig`,
    method: 'POST',
    data: data
  });
}

export function editMenu(data){
  return request({
    url: `/wx/sys/menu/update`,
    method: 'POST',
    data: data
  });
}

export function deleteOss(data){
  return request({
    url: `/wx/sys/oss/delete`,
    method: 'POST',
    data: data
  });
}
